import React, { useState,useEffect } from "react";
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from "../../../../../../_uiComponents/UiInput";
import { Grid } from "@mui/material";
import UiSwitch from "../../../../../../_uiComponents/common/form/UiSwitch";
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import FormControlLabel from "@mui/material/FormControlLabel";
import { UiEditor } from "../../../../../../_uiComponents/common/form/UiStyledInputs";

export default function TermPreview(props) {

    const {term,indexNo,clearDataFunc} = props;

    const clearRow = () =>{
        clearDataFunc(indexNo);
    }

 
    return (
       
                    <div id={"termSection"+indexNo} style={{marginTop:5+'%'}} className="sba-dynamic-content-row">
                        <UiInputGroupWr title="Terms and condition ">
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{ mb: 1 }}
                                >
                                    <Grid item xs={12} lg={6}>
                                        <UiInput
                                            type="text"
                                            label="Title"
                                            name={"termTitle"+indexNo}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{ mb: 1 }}
                                >
                                    <Grid item xs={12} lg={12}>
                                        <UiEditor title="Descirption"/>
                                        {/* <UiInput
                                            type="text"
                                            label="Description"
                                            multiline={true}
                                            minRows={3}
                                            maxRows={5}
                                            name={"description"+indexNo}
                                        /> */}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} lg={6}>

                                    <FormControlLabel
                                        control={
                                                <UiSwitch checked={term.active?term.active:false} name={"active"+indexNo} />
                                        }
                                        label="Active"
                                        labelPlacement="top"
                                        sx={{ mt: 2 }}
                                        className="sba-campaign-switch-label"
                                    />
                                    </Grid>
                                </Grid>
                                <div className="sba-section-remove">
                                    <IconButton>
                                        <ClearIcon onClick={clearRow} color="error" />
                                    </IconButton>
                                </div>
                        </UiInputGroupWr>
                    </div>

        )

}